import { IconButton, makeStyles } from '@material-ui/core'
import { Upload } from 'lucide-react'
import React from 'react'
import { clsx } from 'clsx';

const useStyles = makeStyles((theme) => ({
    outlinedIconButton: {
        color: "#fff",
        border: "1px solid #74747480",
        borderRadius: 6,
        padding: 8,
        fontSize: 14,
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
        },
    }
}));

export default function UploadButton({ text, onClick, isIcon = true, iconSize = 24, styles = {} }: { text: string, onClick: () => void, isIcon?: boolean, iconSize?: number, styles?: any }) {
    const classes = useStyles();
    return (
        <IconButton
            size="small"
            onClick={onClick}
            className={clsx(classes.outlinedIconButton, styles)}
        >
            {isIcon && <Upload style={{ marginRight: 10 }} size={iconSize} />}
            {text}
        </IconButton>
    )
}
